import script from "./AppLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLogo.vue?vue&type=script&setup=true&lang=js"

import "./AppLogo.vue?vue&type=style&index=0&id=6f535954&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f535954"]])

export default __exports__